// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox__checkbox--ZvKGS","disabled":"Checkbox__disabled--iHQoD"};